var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { BackendHttpService } from '../../core/backend-http.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
var ExportInfluencerService = /** @class */ (function (_super) {
    __extends(ExportInfluencerService, _super);
    function ExportInfluencerService(router, translate) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        return _this;
    }
    ExportInfluencerService.prototype.inferFileName = function (mimeType, fileName) {
        fileName += '.';
        switch (mimeType) {
            case 'application/vnd.ms-excel':
                fileName += 'xls';
                break;
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                fileName += 'xlsx';
                break;
        }
        if (mimeType.startsWith('application/pdf')) {
            fileName += 'pdf';
        }
        return fileName;
    };
    ExportInfluencerService.prototype.exportInfluencer = function (_a, _b, fileName, setIsLoading) {
        var _this = this;
        var format = _a.format;
        var url = _b.url, _c = _b.options, options = _c === void 0 ? {} : _c;
        this.handleLoading(setIsLoading, true);
        return this.getBlob(url, {
            headers: { 'Content-Type': 'application/' + format },
            params: __assign({ format: format }, options)
        }).subscribe(function (blob) {
            var _fileName = _this.inferFileName(blob.type, fileName);
            _this.handleExcelDownload(blob, _fileName);
            _this.handleLoading(setIsLoading, false);
        }, function () { return _this.handleLoading(setIsLoading, false); }, function () { return _this.handleLoading(setIsLoading, false); });
    };
    ExportInfluencerService.prototype.handleExcelDownload = function (blob, filename) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // Clean up the DOM
    };
    ExportInfluencerService.prototype.handleLoading = function (isLoading, status) {
        return typeof isLoading === 'function' && isLoading(status);
    };
    return ExportInfluencerService;
}(BackendHttpService));
export { ExportInfluencerService };



// WEBPACK FOOTER //
// ./src/app/main/services/export-influencer.service.ts.pre-build-optimizer.js